var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileSound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 11,
  viewBox: "0 0 10 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m10 0-.01 3.199v4.634a2 2 0 0 1 0 .391v.105h-.012a2 2 0 1 1-1.488-2.24l-.001-2.625-4.5.8.002 4.569.004.046.005.15q0 .098-.01.195v.105h-.012a2 2 0 1 1-1.488-2.24V1.33z"
})));
export default SvgInstagramMobileSound;